'use client'

import { ReactNode } from 'react'

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <section 
      className="min-h-screen bg-white light"
    >
      <main className="h-screen">{children}</main>
    </section>
  )
}